/*
 Provides Props:
 ------------------------------------
 state.format // String - copy of widget.sizeMonitor.state

 Emits:
 --------
 'format' whenever widget.sizeMonitor.state changes.

 */

export default function (state, widget) {

    // ------------------------------------------------

    state.format = widget.sizeMonitor.state;

    // ------------------------------------------------

    widget.sizeMonitor.on(function (format) {
        state.format = format; // === widget.sizeMonitor.state;
        state.emit('format', format);
    });

}
